module.exports = __webpack_public_path__ + "assets/e5871cc28bec0bdf4e1205fbb81406dd.svg";